import CookiesPolicyBar from './CookiesPolicyBar';
export default CookiesPolicyBar;
